import React, { FC, useEffect, useState, } from "react"
import Header, { headerOptionType } from "./Header"
import Footer from "./Footer"
import Styles from "../styles/Layout.module.scss"
import { RightColumn } from "./RightColumn"
import clsx from "clsx"
import MediaQuery from "react-responsive";


type Props = {
    children: React.ReactNode,
    headerOption?: headerOptionType,
    footerHide?: boolean,
    rightColumnContent?: JSX.Element
}

const Layout: FC<Props> = ( {
    children,
    headerOption,
    footerHide,
    rightColumnContent
} ) => {

    const [ renderTrigger, setRenderTrigger ] = useState( false )
    const [ isWebView, setIsWebView ] = useState( false );

    useEffect( () => {
        setIsWebView( !!window.ReactNativeWebView )
    }, [] )

    useEffect( () => {
        setRenderTrigger( !renderTrigger )
    }, [ children ] )

    return (
        <div
            id="clubcloud_layout"
            className={ `${ Styles.container }` }
            style={ isWebView ? { transform: "translate3d(0, -48px, 0)" } : {} }>
            { headerOption && !isWebView &&
                <Header headerOption={ headerOption } /> }
            { rightColumnContent &&
                <MediaQuery query="(min-width: 900px)">
                    <RightColumn>
                        { rightColumnContent }
                    </RightColumn>
                </MediaQuery> }
            <div
                className={ clsx(
                    Styles.main_wrapper,
                    !headerOption && Styles.no_header,
                    footerHide && Styles.no_footer ) }>
                <main className={ Styles.main }>
                    <>
                        { children }
                    </>
                </main>
            </div>
            { !footerHide && !isWebView &&
                <Footer /> }
        </div>
    )
}

export default Layout
